import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  confSmartsLength: 0,  
  confSmartEmpleados: [],
  confSmartEmpleadosLength: 0,
  confSmarts: [],
  confSmart: {},
  confSmartError: "",
  formError: "",
};

export default function ConfSmartReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_CONF_SMART:
      return { ...state, loading: action.payload };
    case actions.LOADING_CONF_SMART_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_CONF_SMART:
      return { ...state, saveLoading: action.payload };
    case actions.GET_CONF_SMART_EMPLEADOS:
      return {
        ...state,
        confSmartEmpleados: action.payload.confSmartEmpleados,
        confSmartEmpleadosLength: action.payload.confSmartEmpleadosLength,
      };
    case actions.GET_CONF_SMART:
      return {
        ...state,
        confSmarts: action.payload.confSmarts,
        confSmartsLength: action.payload.confSmartsLength,
      };
    case actions.GET_CONF_SMART_BY_ID:
      return {
        ...state, confSmart: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.CONF_SMART_FAIL:
      return { ...state, confSmartError: action.payload };

    case actions.CLEAR_FORM_FAIL:
      return { ...state, formError: "" };
    default:
      return state;
  }
}
